export function formatNumber(value: number) {
  return value.toLocaleString('ko-KR');
}
